<!-- eslint-disable -->
<template>
  <loading v-model:active="isLoading" :is-full-page="fullPage" />
  <div id="main" class="layout-horizontal">
    <PrimaryTopBar />
    <div class="content-wrapper container">
      <div class="page-heading"  v-show="!showRinci">
        <h3>Dashboard</h3>
      </div>

      <div class="page-content"  v-show="!showRinci">
        <section class="row">
          <div class="col-12 col-lg-8">
            
            <div class="card">
              <div class="card-content">
                <div class="card-body">
                  <h5 class="card-title">Biodata siswa</h5>
                  <p class="card-text">
                    Informasi biodata siswa.
                  </p>
                </div>
              </div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item"><small>Nomor Induk BPP (NIB)</small><br><label class="label-info">{{ biodata.nis }} </label></li>
                <li class="list-group-item"><small>Nama Lengkap</small><br><label class="label-info">{{ biodata.nama }}</label></li>
                <li class="list-group-item"><small>Jenjang Pendidikan</small><br><label class="label-info">{{ biodata.jenjang + ' Kelas ' + biodata.kelas + ' ' +biodata.kelompok }}</label></li>
                <li class="list-group-item"><small>Tempat & Tanggal Lahir</small><br><label class="label-info">{{ biodata.tempat_lahir }}, {{ $filters.formatTglView(biodata.tanggal_lahir) }}</label></li>
                <li class="list-group-item"><small>Alamat</small><br><label class="label-info">{{ biodata.alamat }}</label></li>
                <li class="list-group-item"><small>Nomor HP</small><br><label class="label-info">{{ biodata.telpon }}</label></li>
                <li class="list-group-item"><small>Nama Ayah</small><br><label class="label-info">{{ biodata.nama_ayah }}</label></li>
              </ul>
            </div>
            
          </div>
          <div class="col-12 col-lg-4">
            <div class="card">
              <div class="card-body px-3 py-4-5 bg-purple">
                <div class="row">
                  <div class="col-md-4">
                    <div class="stats-icon warning">
                      <i class="iconly-boldBuy"></i>
                    </div>
                  </div>
                  <div class="col-md-8">
                    <h6 class="font-semibold text-light">Tagihan belum dibayar</h6>
                    <h4 class="font-extrabold mb-0">Rp. {{ $filters.currencyUSD(jumlahTagihan)  }}</h4>
                  </div>
                </div>
              </div>
              <ul class="list-group list-group-flush">
                <li class="list-group-item">
                  <small>Nomor Virtual Account Bank BSI ex BSM </small><br><label class="label-info">900 9129 {{ biodata.nis }}</label><br>
                  <small class="text-primary">900&nbsp; &nbsp; &nbsp; &nbsp; : Kode VA Bank BSI ex BSM</small><br>
                  <small class="text-primary">9129&nbsp; &nbsp; &nbsp; : Kode Yayasan Alkautsar</small><br>
                  <small class="text-primary">{{ biodata.nis }} : NIB / ID Pelanggan</small>

                </li>
                <li class="list-group-item">
                  <small>Nomor Virtual Account Bank BSI ex BRIS </small><br><label class="label-info">900 9457 {{ biodata.nis }}</label><br>
                  <small class="text-primary">900&nbsp; &nbsp; &nbsp; &nbsp; : Kode VA Bank BSI ex BRIS</small><br>
                  <small class="text-primary">9457&nbsp; &nbsp; &nbsp; : Kode Yayasan Alkautsar</small><br>
                  <small class="text-primary">{{ biodata.nis }} : NIB / ID Pelanggan</small>

                </li>
                <li class="list-group-item"><small>Nomor Virtual Account Bank Muamalat</small><br><label class="label-info">8571680000 {{ biodata.nis }}</label></li>
              </ul>
            </div>
            <button class="btn btn-purple btn-block shadow-lg mt-4 rounded-pill" @click.prevent="onRincianTagihan()">Lihat Rincian</button>
            <router-link :to="{path: '/riwayatpembayaran'}"  class="btn btn-primary btn-block shadow-lg mt-2 rounded-pill">Riwayat Pembayaran</router-link>
            <router-link :to="{path: '/petunjukpembayaran'}"  class="btn btn-dark btn-block shadow-lg mt-2 rounded-pill">Tatacara Pembayaran</router-link>
          </div>
        </section>
      </div>
      
      <div class="page-heading"  v-show="showRinci">
        <h3><a @click.prevent="offRincianTagihan()" class="icon-back"><i class="bi bi-chevron-left"></i></a> Rincian Tagihan</h3>
      </div>
      <RincianTagihan v-bind:dataRincian="dataTagihan" v-bind:dataJumlah="jumlahTagihan" v-show="showRinci"/>
    </div>
    
  </div>
</template>
<!-- eslint-disable -->
<script>
import axios from "axios";
import PrimaryTopBar from "@/components/layout/PrimaryTopBar.vue";
import RincianTagihan from "@/components/RincianTagihan.vue";
import Loading from 'vue-loading-overlay';

export default {
  name: "Dashboard",
  components: {
    PrimaryTopBar,
    RincianTagihan,
    Loading
  },
  data() {
    return {
      biodata: [],
      getKey : '',
      formTagihan : [],
      dataTagihan : [],
      jumlahTagihan : '0',
      isLoading: false,
      showRinci:false,
      fullPage: true,
    };
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    async loadPage() {
      this.isLoading = true;
      if(localStorage.getItem('setusers')){
        this.biodata = JSON.parse(localStorage.getItem('setusers'));
        this.getKey  = localStorage.getItem('token');
      }

      this.getTagihan();
      setTimeout(() => {
        this.isLoading = false;
      }, 1000);
    },
    async getTagihan() {
      this.isLoading = true;
      this.formTagihan = { nis:this.biodata.nis, key:this.getKey };
      await axios.post('/api/public/tagihan',JSON.stringify(this.formTagihan)).then(response => {
          let data = response.data;
          if(data.code === '200') {
            let row = data.records;

            if(row.code === '00') {
              let jumlah = row.data.totalNominal;
              this.jumlahTagihan = (jumlah > 0) ? jumlah - 2000 : jumlah;
              this.dataTagihan = row.data.rincianTagihan;
            }
          }
      });
    },
    async onRincianTagihan () { 
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.showRinci = true;
      }, 500);
    },
    async offRincianTagihan () { 
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        this.showRinci = false;
      }, 500);
    }
  }
}
</script>